<template>
  <div class="pd-t170 main-column theme-style-01" id="main-column">
    <!-- 二级栏目 begin -->
    <router-view></router-view>
    <!-- 二级栏目 end -->
  </div>
</template>

<script>
  import crumb from './crumb'
	export default {
		name: "Main",

    components: {
      crumb
    },

    data() {
      return {
        leftMenu: []
      }
    },

    methods: {
      getMenu() {
        if (this.$route.name === 'service-objective' || this.$route.name === 'service-details') {
          this.leftMenu = [
            {
              isShowChildren: false,
              name: '服务目标',
              routerName: 'service-objective',
              type: 'button',
              children: [
                {
                  name: '服务目标',
                  routerName: 'service-objective',
                  type: 'link',
                },
                {
                  name: '服务目标',
                  routerName: 'service-objective',
                  type: 'link',
                }
              ]
            },
            {
              isShowChildren: false,
              name: '服务内容',
              routerName: 'service-details',
              type: 'link',
              children: []
            }
          ]
        }
      },

      switchShow(item) {
        console.log(item);
        item.isShowChildren === true ? this.$set(item, 'isShowChildren', false) : this.$set(item, 'isShowChildren', true)
      },

      goToPage(item) {
        if (item.type === 'link' && this.$route.name !== item.routerName) {
          this.$router.push({
            name: item.routerName
          })
        }
      }
    },

    mounted() {

      // $('.left-menu-list').delegate('.left-menu-list-item', 'click', function () {
      //   console.log(1);
      // });

      /*$('.left-menu-list').unbind("click").delegate('.left-menu-list-item-title', 'click', function (e) {
        e.stopPropagation();
        $(this).toggleClass('is-active');
        $(this).siblings('.left-menu-list-item-children-list').slideToggle(300);

        $(this).parents('.left-menu-list-item').siblings('.left-menu-list-item').find('.left-menu-list-item-title').removeClass('is-active');
        $(this).parents('.left-menu-list-item').siblings('.left-menu-list-item').find('.left-menu-list-item-children-list').slideUp(300);
      });*/

      $(window).scroll(function () {
        console.log($('#main-column').offset);
      });



      // this.getUserInfo();
      /*let menuScrollBox = $('#menu-scroll-box');
      menuScrollBox.mCustomScrollbar({
        set_width: false,
        set_height: false,
        // horizontalScroll: false,
        axis:"y",
        scrollInertia: 100, // 滚动条惯性(值越大惯性越大)
        scrollEasing: "easeOutCirc",
        mouseWheel: true, //
        autoDraggerLength: true,
        scrollButtons: {
          enable: false,
          scrollType: "continuous",
          scrollSpeed: 20,
          scrollAmount: 20
        },
        advanced:{
          updateOnBrowserResize: true,
          updateOnContentResize: true,
          autoExpandHorizontalScroll: true,
          autoScrollOnFocus: true
        },
        callbacks:{
          onScrollStart: function(){},
          onScroll: function(){},
          onTotalScroll: function(){},
          onTotalScrollBack: function(){},
          onTotalScrollOffset: 0,
          whileScrolling: false,
          whileScrollingInterval: 10
        }
      });*/
    },

    watch: {
      'this.$route': {
        handle(to, from) {

        },
        deep: true
      }
    }
	}
</script>

<style>


</style>
